'use client'

import { t } from '@lingui/core/macro'
import { Trans } from '@lingui/react/macro'
import { Box, Paper, Typography } from '@mui/material'

export function EthicsInfo() {
  const steps = [
    t`Submit your question using the form below`,
    t`Our team reviews and processes your question`,
    t`A response is drafted and published`,
    t`You can view the response on this page`,
  ]

  return (
    <Paper
      elevation={0}
      sx={{
        p: { xs: 2.25, sm: 3 },
        mb: { xs: 4, sm: 5 },
        borderRadius: 3,
        bgcolor: '#f3f4f5',
        borderLeft: '4px solid',
        borderLeftColor: 'primary',
      }}
    >
      <Typography variant="h6" sx={{ fontWeight: 800, color: '#191c1d', mb: 2 }}>
        <Trans>Continuous Improvement Process</Trans>
      </Typography>
      <Typography variant="body2" sx={{ color: '#4a4454', mb: 3, lineHeight: 1.75 }}>
        <Trans>
          Our platform is committed to transparency and ethical use of your data. You can submit any ethical question or concern you may have. Each question is
          reviewed by our team, and a response will be published once it has been addressed.
        </Trans>
      </Typography>
      <Box component="ol" sx={{ listStyle: 'none', m: 0, p: 0, display: 'flex', flexDirection: 'column', gap: 2 }}>
        {steps.map((step, i) => (
          <Box component="li" key={i} sx={{ display: 'flex', alignItems: 'flex-start', gap: 2 }}>
            <Box
              sx={{
                width: 24,
                height: 24,
                borderRadius: '50%',
                bgcolor: 'primary.main',
                color: '#ede0ff',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: 12,
                fontWeight: 700,
                flexShrink: 0,
                mt: '2px',
              }}
            >
              {i + 1}
            </Box>
            <Typography variant="body2" sx={{ color: '#191c1d', lineHeight: 1.55 }}>
              {step}
            </Typography>
          </Box>
        ))}
      </Box>
    </Paper>
  )
}
